<template>
    <div>
        <TopbarCustom :loggedIn="true"></TopbarCustom>
        <!-- <LoadingBar clazz="center-floating full-view"
        loadingText="Tu pago está siendo procesado, despues seras
        redirigido a la pagina Monique Fashion"
        extraText="Esto puede tardar unos minutos…">
        </LoadingBar> -->
        <!-- MAIN CONTENT PAGE -->
        <div id="main-view">
            <div class="page-container">
                <strong class="c-error f-20 m-b-30 d-block">NOTA: El componente de loading page esta
                comentado en TransferPayment.vue linea 4 (borrar esta nota)</strong>
                <div class="payment-container">
                    <div class="left-container">
                        <div class="payment-steps">
                            <a href="#"
                                type="button"
                                class="change-payment-method">
                                <i aria-hidden="true" class="iconsax-arrow-back-square c-primary"></i>
                                Cambiar forma de pago
                            </a>
                                <div class="accordion" role="tablist">
                                <div class="item complete">
                                    <div class="title-collapsible" v-b-toggle.datos-personales>
                                        <div class="circle">
                                            <i aria-hidden="true" class="iconsax-essential-tick-circle"></i>
                                        </div>
                                        <div>
                                            <span>PASO 01</span>
                                            <h3>
                                                Pago por transferencia
                                            </h3>
                                        </div>
                                    </div>
                                    <b-collapse class="accordion-container" id="datos-personales" visible accordion="my-accordion" role="tabpanel">
                                        <div class="row p-t-15">
                                            <div class="col-12">
                                                <p class="description">
                                                    Introduce tu nombre y correo para enviarte una copia de las
                                                    instrucciones para reliazar el pago por transferencia.
                                                </p>
                                            </div>
                                            <div class="col-12">
                                                <BasicInput
                                                    required
                                                    label="Nombre"
                                                    inputPlaceholder="Ingresa tu nombre"
                                                    inputId="nameID">
                                                </BasicInput>
                                            </div>
                                            <div class="col-12">
                                                <BasicInput
                                                    required
                                                    label="Correo electrónico"
                                                    inputPlaceholder="Ingresa tu dirección de correo electrónico"
                                                    inputId="correoID">
                                                </BasicInput>
                                            </div>
                                            <div class="col-12">
                                                <button class="button button-filled button-primary" v-b-toggle.direccion>Continuar</button>
                                                <button class="button button-filled button-primary disabled" v-b-toggle.direccion>Continuar</button>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                                <div class="item">
                                    <div class="title-collapsible" v-b-toggle.direccion>
                                        <div class="circle">
                                            <i aria-hidden="true" class="iconsax-essential-tick-circle"></i>
                                        </div>
                                        <div>
                                            <span>PASO 02</span>
                                            <h3>
                                                Referencia
                                            </h3>
                                        </div>
                                    </div>
                                    <b-collapse class="accordion-container" id="direccion" accordion="my-accordion" role="tabpanel">
                                        <div class="row p-t-30">
                                            <div class="col-12">
                                                <p class="description">
                                                    Con la siguiente CLABE interbancaria podrás realizar el pago mediante
                                                    transferencia desde el banco de tu preferencia.
                                                    <br><br>
                                                    Recuerda realizar la transferencia por la cantidad exacta de esta ficha,
                                                    de lo contrario se rechazará el pago.
                                                </p>
                                            </div>
                                            <div class="col-12 col-lg-7">
                                                <ReadOnlyInfo
                                                    title="CLABE Interbancaria"
                                                    text="646118012260000735"
                                                >
                                                    <button class="button button-filled button-primary xxs m-l-10">Copiar</button>
                                                </ReadOnlyInfo>
                                            </div>
                                            <div class="col-12 col-lg-5">
                                                <ReadOnlyInfo
                                                    title="Número de orden"
                                                    text="200014"
                                                ></ReadOnlyInfo>
                                            </div>
                                            <div class="col-12 col-lg-7">
                                                <ReadOnlyInfo
                                                    title="Nombre del beneficiario"
                                                    text="Monique Fashion"
                                                    clazz="sm"
                                                ></ReadOnlyInfo>
                                            </div>
                                            <div class="col-12 col-lg-5">
                                                <ReadOnlyInfo
                                                    title="Vigencia para hacer el pago"
                                                    text="02 Feb. antes de las 10:20 AM"
                                                    clazz="sm"
                                                ></ReadOnlyInfo>
                                            </div>
                                            <div class="col-12">
                                                <div class="list-title">Instrucciones para pago por transferencia</div>
                                                <ul class="list">
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            Ve a tu aplicación de banco o banca en línea y elige la opción
                                                            <span>"Transferencia a otros bancos".</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            Elige como banco destino a:
                                                            <span>"Sistema de Transferencias y Pagos".</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            En el campo CLABE ingresa los 18 dígitos:
                                                            <span>646118012260000735</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            En el campo Referencia ingresa el número de orden:
                                                            <span>2000014</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            Ingresa el nombre del beneficiario:
                                                            <span>Monique Fashion</span>
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            Realiza la transferencia.
                                                        </div>
                                                    </li>
                                                    <li>
                                                        <i aria-hidden="true" class="iconsax-arrow-circle-right-1"></i>
                                                        <div>
                                                            ¡Listo!, a los pocos minutos de realizar la transferencia te notificaremos del pago realizado.
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-12 m-t-30">
                                                <b-alert class="alert-note" show variant="info">
                                                    <p class="text-container">
                                                        <i
                                                            aria-hidden="true"
                                                            class="icon iconsax-emails-message-text"
                                                            ></i>
                                                        Recuerda que te hemos enviado un correo con estas instrucciones para que puedas
                                                        realizar el pago en el transcurso de 24 horas.
                                                    </p>
                                                </b-alert>
                                            </div>
                                        </div>
                                    </b-collapse>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="right-container">
                        <CardDetailPayment
                        title="Detalle de tu pago"
                        total="1,690.80"
                        :payBtn="false"
                        >
                            <BusinessInfo
                                logo="https://static.pagando.mx/prod/images/6103074494ccac0007713570"
                                name="Monique Fashion"
                                phone="(614) 123-5678"
                                mail="finanzas.monique@gmail.com"
                            />
                        </CardDetailPayment>
                    </div>
                    <BottomFloatingNote
                    text="Pagando Copyright 2021, una marca registrada de"
                    strong="Black Labs S.A. de C.V."
                    />
                </div>
                <router-link to="#" class="sm button button-ghost button-info ml-auto mr-auto ml-md-0" tabindex="">
                    <i aria-hidden="true" class="iconsax-arrow-circle-left-1 c-primary m-r-10"></i>
                    Volver a las opciones de pago
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import TopbarCustom from '@/components/Topbar.vue'
import BottomFloatingNote from '@/components/BottomFloatingNote.vue'
import CardDetailPayment from '@/components/CardDetailPayment.vue'
import BusinessInfo from '@/components/BusinessInfo.vue'
import BasicInput from '@/components/BasicInput.vue'
import ReadOnlyInfo from '@/components/ReadOnlyInfo.vue'

export default {
    name: "TransferPayment",
    components: {
        TopbarCustom,
        BottomFloatingNote,
        CardDetailPayment,
        BusinessInfo,
        BasicInput,
        ReadOnlyInfo
    },
    data () {
        return {
        }
    },
};
</script>
